import { render, staticRenderFns } from "./LookBigImage.vue?vue&type=template&id=6fe1c1ec&scoped=true&"
import script from "./LookBigImage.vue?vue&type=script&lang=js&"
export * from "./LookBigImage.vue?vue&type=script&lang=js&"
import style0 from "./LookBigImage.vue?vue&type=style&index=0&id=6fe1c1ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe1c1ec",
  null
  
)

export default component.exports